import React from 'react';
import { motion } from 'framer-motion';

const FinalCTA = () => {
  const handleScrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F9F5F0' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Calm Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759851949674-blob" 
              alt="Sanfte Lichtstimmung – Ruhe und Wärme" 
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center lg:text-left"
          >
            <h2 className="text-4xl md:text-5xl font-serif mb-8" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
              Es ist Zeit, loszulassen
            </h2>
            <p className="text-lg leading-relaxed mb-8" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
              Gönn dir Zeit, die nur dir gehört.<br />
              Dein Körper darf loslassen, dein Geist darf still werden.<br /><br />
              Wir halten den Raum für dich – achtsam, warm und präsent.<br />
              Du musst nichts leisten. Du darfst einfach ankommen.
            </p>
            
            {/* Signature */}
            <div className="mb-8">
              <p className="text-3xl mb-6" style={{ fontFamily: 'Dancing Script, cursive', color: '#314C40' }}>
                Nadine und Marcella
              </p>
            </div>

            <motion.button
              onClick={handleScrollToContact}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 rounded-full text-lg font-semibold transition-colors duration-200 shadow-lg text-white"
              style={{ fontFamily: 'Lato, sans-serif', backgroundColor: '#314C40' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#3E5E51'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#314C40'}
            >
              Platz sichern
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;